import { IconProps } from './index';

const ArrowRightSLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M10.977 10L6.852 5.875 8.03 4.697 13.333 10 8.03 15.303l-1.178-1.178L10.977 10z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowRightSLine;
